import React, { useEffect, useState } from "react";
import formatDateAndTime from "../../common/formatDateAndTime";
import { TextField } from "@mui/material";
import toast from "react-hot-toast";
import InfoIcon from "@mui/icons-material/Info";
import moment from "moment";
import UseOnlineStatus from "../../common/UseOnlineStatus";

const Initiatebooking = ({
  summaryDetails,
  vehicleDetails,
  paymentDetailsData,
  fleetDeliveryAgentList,
  setActiveTab,
  setOpenTab,
  getBookingDetail,
  selectedRow,
  paymentDetails,
  fareBreakUpDetails,
  getVehicleDetial,
  from,
  setActiveItem,
  getAllBookings,
  rowsPerPage,
}) => {
  const { isOnline, isSlowConnection } = UseOnlineStatus();
  const apiUrl = process.env.REACT_APP_API_BASE_URL;
  const token = localStorage.getItem("token");
  const fuelType = JSON.parse(localStorage.getItem("catalogValues"))?.fuelType;
  delete fuelType?.inverted;
  const vehicleBodyType = JSON.parse(
    localStorage.getItem("catalogValues"),
  )?.vehicleBodyType;
  delete vehicleBodyType?.inverted;
  const vehicleBookingStatus = JSON.parse(
    localStorage.getItem("catalogValues"),
  )?.vehicleBookingStatus;
  delete vehicleBookingStatus?.inverted;
  const fleetBookingStatus = JSON.parse(
    localStorage.getItem("catalogValues"),
  )?.fleetBookingStatus;
  let bookingTypes = JSON.parse(
    localStorage.getItem("catalogValues"),
  )?.bookingTypes;
  const profile = JSON.parse(localStorage.getItem("profile"));
  const [paymentLink, setPaymentLink] = useState(null);
  const [initiateLoading, setInitiateLoading] = useState(false);

  const [transactiondetails, settransactiodetails] = useState({
    transactionid: "",
    transactioncharges: "",
    paymentmode: "",
    payableamount: "",
    paymentremarks: "",
    attachments: null,
  });
  const [selectedFile, setSelectedFile] = useState(null);
  const [vehicleDetailsData, setVehicleDetailsData] = useState({
    id: "",
    name: "",
    vehicleNo: "",
    comment: "",
  });
  const [radioValues, setRadioValues] = useState("Continue Booking");
  const [availableVehicles, setAvailableVehicles] = useState([]);
  const [vehicleBookingsData, setVehicleBookingsData] = useState(null);
  const [errors, setErrors] = useState({});
  const [addpaymentErrors, setAddPaymentErrors] = useState("");
  const [paymentLinkGenerated, setPaymentLinkGenerated] = useState(false);

  const hasUnstableConnection = !isOnline || isSlowConnection;

  const showNetworkAlert = () => {
    setPaymentLinkGenerated(false);
    toast.error(
      "Please check your network connection. Your internet connection appears to be unstable.",
      {
        position: "bottom-center",
        style: {
          background: "white",
          color: "red",
          fontWeight: "medium",
          marginBottom: "20px",
        },
      },
    );
  };

  const generatepaymentlink = async (type) => {
    if (hasUnstableConnection) {
      showNetworkAlert();
      return;
    }

    setPaymentLinkGenerated(true);
    let payload;

    if (type === "generate") {
      payload = {
        bookingId: summaryDetails?.id,
        amount: Math.round(summaryDetails?.costToCustomer * 100),
        customerName: summaryDetails?.customerName,
        contactEmail: summaryDetails?.customerEmail,
        customerContact: summaryDetails?.customerMobile,
        customerId: summaryDetails?.customerId,
      };
    } else {
      payload = {
        paymentId: paymentLink?.paymentId,
        id: paymentLink?.id,
        bookingId: summaryDetails?.id,
        inquiryCode: summaryDetails?.inquiryCode,
      };
    }

    toast.loading("Processing... Please wait", {
      id: "initiateTransaction", // same ID to update later
      position: "bottom-center",
    });

    try {
      const response = await fetch(`${apiUrl}/api/paymentlinks`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: `${token}`,
        },
        body: JSON.stringify(payload),
      });
      const data = await response.json();
      toast.dismiss("initiateTransaction");
      if (data?.statusCode === "0100") {
        setPaymentLinkGenerated(false);
        if (data?.dataValues?.status === "created") {
          toast.success("Payment link generated successfully");
          // setActiveItem("View all Bookings");
        } else {
          toast.success("Payment Captured successfully");
        }
        setPaymentLink(data?.dataValues);
        if (from === "inquiry" && data?.dataValues?.status === "captured") {
          setActiveItem("View all Bookings");
          getBookingDetail(selectedRow?.inquiryID, "inquiry");
        }
      } else {
        setPaymentLinkGenerated(false);
        toast.error(data?.msg);
      }
      return data;
    } catch (error) {
      return;
      setPaymentLinkGenerated(false);
      console.error("Error fetching generate payment link:", error);
    }
  };

  const initiateBookingAPI = async (type) => {
    if (!summaryDetails?.customerEmail) {
      return toast.error("Customer email is missing, cannot proceed.");
    }

    if (initiateLoading) return; // prevent double submit
    setInitiateLoading(true);

    toast.loading("Processing... Please wait", {
      id: "initiate", // same ID to update later
      position: "bottom-center",
    });

    if (!vehicleDetailsData?.name && type !== "Close") {
      toast.dismiss("initiate");
      setInitiateLoading(false);
      return toast.error(
        "Select the available vehicle before initiating booking",
        {
          position: "bottom-center",
          style: {
            background: "white",
            color: "red",
            fontWeight: "medium",
            marginBottom: "20px",
          },
        },
      );
    }

    toast.dismiss("initiate");
    if (!vehicleDetailsData?.comment) {
      setInitiateLoading(false);
      return toast.error("Enter comment to close or initate booking", {
        position: "bottom-center",
        style: {
          background: "white",
          color: "red",
          fontWeight: "medium",
          marginBottom: "20px",
        },
      });
    }

    let payload;

    if (type === "Close") {
      payload = {
        id: summaryDetails?.id,
        comment: vehicleDetailsData?.comment,
        bookingStatus: fleetBookingStatus?.inverted?.inquiryClosed,
        isInquiryClosed: true,
        bookingClosedAt: moment(new Date()).format("YYYY-MM-DDTHH:mm"),
        bookingClosedBy: profile?.id,
      };
    } else {
      payload = {
        id: summaryDetails?.id,
        vehicleId: vehicleDetailsData?.id,
        vehicleRegistrationNo: vehicleDetailsData?.vehicleNo,
        vehicleName: vehicleDetailsData?.name,
        comment: vehicleDetailsData?.comment,
        bookingStatus: fleetBookingStatus?.inverted?.paymentPending,
        bookingHistory: {
          agentId: profile?.id,
          agentName: profile?.name,
          emailId: profile?.email,
          action: "Booking Initiated",
          bookingId: summaryDetails?.id,
        },
      };
    }
    // console.log("Initiate Booking Payload:", payload);
    // return

    try {
      const response = await fetch(`${apiUrl}/api/vehiclebookings`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: `${token}`,
        },
        body: JSON.stringify(payload),
      });
      const data = await response.json();

      toast.dismiss("initiate");
      setInitiateLoading(false);

      if (data?.statusCode === "0100") {
        toast.success("Booking updated successfully!", {
          position: "bottom-center",
        });

        setVehicleBookingsData(data?.dataValues);
        if (type === "Close") {
          setVehicleBookingsData(null);
          getAllBookings(0, rowsPerPage, true);
          setOpenTab(false);
        }
      } else {
        toast.error(data?.message || "Something went wrong!", {
          position: "bottom-center",
        });
      }

      return data;
    } catch (error) {
      toast.dismiss("initiate");
      setInitiateLoading(false);

      toast.error("API failed, please try again!", {
        position: "bottom-center",
      });

      return console.error("Error fetching initiate booking:", error);
    }
  };

  const transactionDetailsInput = [
    {
      label: "Transaction Id",
      type: "text",
      isEnable: false,
      placeholder: "",
      value: "transactionid",
    },
    {
      label: "Transaction Charges",
      type: "text",
      isEnable: false,
      placeholder: "",
      value: "transactioncharges",
    },
    {
      label: "Payment Mode",
      type: "text",
      isEnable: false,
      placeholder: "",
      value: "paymentmode",
    },
    {
      label: "Payable Amount",
      type: "text",
      isEnable: false,
      placeholder: "",
      value: "payableamount",
    },
    {
      label: "Payment Remarks",
      type: "text",
      isEnable: false,
      placeholder: "",
      value: "paymentremarks",
    },
    {
      label: "Attachments",
      type: "file",
      isEnable: false,
      placeholder: "",
      value: "attachments",
    },
  ];

  function formatDateForApi(dateInput) {
    const date = new Date(dateInput); // convert string to Date

    const pad = (n) => (n < 10 ? "0" + n : n);
    const year = date.getFullYear();
    const month = pad(date.getMonth() + 1);
    const day = pad(date.getDate());
    const hours = pad(date.getHours());
    const minutes = pad(date.getMinutes());

    return `${year}-${month}-${day}T${hours}:${minutes}`;
  }

  const formattedStartDate = formatDateForApi(summaryDetails?.bookFrom);
  const formattedEndDate = formatDateForApi(summaryDetails?.bookTo);

  const getAvailableVehicleINGroup = async () => {
    let query = "";

    if (formattedStartDate) {
      query += `startDate=${formattedStartDate}`;
    }

    if (formattedEndDate) {
      query += `&endDate=${formattedEndDate}`;
    }

    if (summaryDetails?.vehicleGroupId) {
      query += `&groupId=${summaryDetails.vehicleGroupId}`;
    }

    if ((String(summaryDetails?.bookingType) === String(bookingTypes?.inverted?.subscription) || String(summaryDetails?.bookingType) === String(bookingTypes?.inverted?.shortSubscription)) && summaryDetails?.bookingType !== null) {
      query += `&isSubscriptionBooking=true`;
    }

    const apiUrlEndpoint = `${apiUrl}/api/vehiclebookings/v2/searchvehiclesbygroupanddate?${query}`;
    try {
      const response = await fetch(
        `${apiUrlEndpoint}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        },
      );
      const data = await response.json();
      if (data?.statusCode === "0100") {
        setAvailableVehicles(data?.dataValues);
      }
      return data;
    } catch (error) {
      return console.error(
        "Error fetching get available vehicle for initiate booking:",
        error,
      );
    }
  };

  useEffect(() => {
    if (summaryDetails?.id) {
      getAvailableVehicleINGroup();
    }
  }, [summaryDetails]);

  useEffect(() => {
    if (summaryDetails?.costToCustomer) {
      settransactiodetails((prev) => ({
        ...prev,
        payableamount: summaryDetails?.costToCustomer,
      }));
    }
  }, [summaryDetails]);

  const handleInitiateBooking = async () => {
    if (hasUnstableConnection) {
      showNetworkAlert();
      return;
    }

    let isValid = true;
    const newErrors = {};

    const requiredFields = [
      "transactionid",
      "transactioncharges",
      "paymentmode",
      "payableamount",
      "paymentremarks",
      "attachments",
    ];

    requiredFields.forEach((field) => {
      if (!transactiondetails[field]) {
        newErrors[field] = "* Required";
        isValid = false;
      } else {
        const valid = validateField(field, transactiondetails[field]);
        if (!valid) isValid = false;
      }
    });

    setErrors(newErrors);

    if (!isValid) {
      toast.error("Please fix errors before submitting payment details");
      return;
    }

    try {
      const response = await fetch(`${apiUrl}/api/bookingtransactions`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: `${token}`,
        },
        body: JSON.stringify({
          amount: transactiondetails?.payableamount,
          paymentMode: transactiondetails?.paymentmode,
          transactionCode: transactiondetails?.transactionid,
          transactionalCharges: transactiondetails?.transactioncharges,
          bookingId: summaryDetails?.id,
          description: transactiondetails?.paymentremarks,
          attachments: transactiondetails?.attachments
            ? JSON.stringify(transactiondetails.attachments)
            : null,
        }),
      });

      const data = await response.json();

      if (data?.statusCode === "0100") {
        toast.success("Payment added successfully");

        if (from === "inquiry") {
          setActiveItem("View all Bookings");
        }

        getBookingDetail(selectedRow?.inquiryID, "inquiry");
      } else {
        toast.error(data?.msg || "Failed to add payment");
        setAddPaymentErrors("* Failed to add payment");
      }

      return data;
    } catch (error) {
      console.error("POST booking transaction error:", error);

      toast.error("Something went wrong!");
    }
  };

  const validateField = (key, value) => {
    let errorMsg = "";

    if (key === "transactioncharges" && !/^\d+$/.test(value)) {
      errorMsg = "* Accepts only numbers";
    }
    if (key === "payableamount" && !/^\d+(\.\d{1,2})?$/.test(value)) {
      errorMsg = "* Accepts only numbers (up to 2 decimals)";
    }
    if (key === "documentype" && !value) {
      errorMsg = "Please select a document type";
    }
    if (key === "paymentmode" && !/^[a-zA-Z ]*$/.test(value)) {
      errorMsg = "* Accepts only alphabets";
    }
    if (key === "attachments" && !value) {
      errorMsg = "* Attachment required";
    }

    setErrors((prev) => ({ ...prev, [key]: errorMsg }));
    return errorMsg === "";
  };

  const handleInputChange = async (key, event) => {
    let value;

    if (event?.target?.type === "file") {
      value = event.target.files[0];

      if (value) {
        const formData = new FormData();
        formData.append("entityName", "booking");
        formData.append("fileTags", "vehicle");
        formData.append("files", value);

        try {
          const response = await fetch(`${apiUrl}/fileapi/upload`, {
            method: "POST",
            body: formData,
          });
          const data = await response.json();
          if (data) {
            toast.success("Image Uploaded successfully.", {
              position: "bottom-center",
              style: {
                background: "blue", // override background
                color: "white",
                fontWeight: "medium",
                marginBottom: "20px",
              },
            });
            setSelectedFile(data?.uploaded);
            settransactiodetails((prev) => ({
              ...prev,
              attachments: data?.uploaded,
            }));
            validateField("attachments", data?.uploaded);
          }
        } catch (error) {
          console.error("Error uploading file:", error);
        }
      }
    } else {
      value = event?.target?.value !== undefined ? event.target.value : event;

      settransactiodetails((prev) => ({
        ...prev,
        [key]: value,
      }));
    }
    validateField(key, value);
  };

  const checkVehicleAvailability = async () => {
    console.log("payyyyl", {
      id: summaryDetails?.id,
      bookFrom: moment(summaryDetails?.bookFrom).format("YYYY-MM-DDTHH:mm"),
      bookTo: moment(summaryDetails?.bookTo).format("YYYY-MM-DDTHH:mm"),
      vehicleId: vehicleDetailsData?.id
        ? vehicleDetailsData?.id
        : summaryDetails?.vehicleId,
      bookingStatus: summaryDetails?.bookingStatus,
      vehicleGroupId: summaryDetails?.vehicleGroupId,
      source: "admin",
    });
    // return
    try {
      const response = await fetch(`${apiUrl}/api/vehiclebookings`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: `${token}`,
        },
        body: JSON.stringify({
          id: summaryDetails?.id,
          bookFrom: moment(summaryDetails?.bookFrom).format("YYYY-MM-DDTHH:mm"),
          bookTo: moment(summaryDetails?.bookTo).format("YYYY-MM-DDTHH:mm"),
          vehicleId: vehicleDetailsData?.id
            ? vehicleDetailsData?.id
            : summaryDetails?.vehicleId,
          bookingStatus: summaryDetails?.bookingStatus,
          vehicleGroupId: summaryDetails?.vehicleGroupId,
          source: "admin",
        }),
      });
      const data = await response.json();

      if (data?.statusCode === "0100") {
        setVehicleBookingsData(data?.dataValues);
        // toast.success("Booking updated successfully!", {
        //   position: "bottom-center",
        // });
      } else {
        toast.error(data?.msg || "Something went wrong!", {
          position: "bottom-center",
        });
      }

      return data;
    } catch (error) {
      toast.dismiss("initiate");
      setInitiateLoading(false);

      toast.error("API failed, please try again!", {
        position: "bottom-center",
      });

      return console.error("Error fetching initiate booking:", error);
    }
  };

  useEffect(() => {
    if (vehicleDetailsData?.id && radioValues === "Continue Booking") {
      checkVehicleAvailability();
    }
  }, [vehicleDetailsData?.id]);

  return (
    <div className="p-6">
      <h2 className="text-2xl font-semibold text-[#2c3e50] mb-8">
        Initiate Booking
      </h2>

      <div className="flex gap-6 p-4 bg-gradient-to-br from-green-50 to-green-100 rounded-2xl shadow-lg w-fit mt-6">
        <label className="flex items-center gap-2 cursor-pointer">
          <input
            type="radio"
            name="bookingOption"
            value="Continue Booking"
            checked={radioValues === "Continue Booking"}
            onChange={(e) => {
              setRadioValues(e.target.value);
              setVehicleDetailsData({
                id: "",
                name: "",
                vehicleNo: "",
                comment: "",
              });
            }}
            className="w-4 h-4 text-blue-600 border-gray-300 focus:ring-blue-500"
          />
          <span className="text-gray-800 font-medium">Continue Booking</span>
        </label>

        <label className="flex items-center gap-2 cursor-pointer">
          <input
            type="radio"
            name="bookingOption"
            value="Close Inquiry"
            checked={radioValues === "Close Inquiry"}
            onChange={(e) => {
              setRadioValues(e.target.value);
              setVehicleDetailsData({
                id: "",
                name: "",
                vehicleNo: "",
                comment: "",
              });
            }}
            className="w-4 h-4 text-blue-600 border-gray-300 focus:ring-blue-500"
          />
          <span className="text-gray-800 font-medium">Close Inquiry</span>
        </label>
      </div>

      {vehicleBookingsData && radioValues !== "Close Inquiry" && (
        <div className="p-6 mt-6 bg-gradient-to-br from-blue-50 to-blue-100 shadow-md rounded-2xl">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
            {[
              // {
              //   name: "Booking Id",
              //   value: summaryDetails?.bookingCode,
              // },
              {
                name: "Inquiry Id",
                value: vehicleBookingsData?.inquiryCode,
              },
              {
                name: "Generated On",
                value: formatDateAndTime(vehicleBookingsData?.createdAt),
              },
              {
                name: "Status",
                value: fleetBookingStatus[vehicleBookingsData?.bookingStatus],
              },
              {
                name: "Start Date",
                value: formatDateAndTime(vehicleBookingsData?.bookFrom),
              },
              {
                name: "End Date",
                value: formatDateAndTime(vehicleBookingsData?.bookTo),
              },
              {
                name: "Total Booking Hrs",
                value: vehicleBookingsData?.bookingHrs + " hrs",
              },
              { name: "Vehicle Name", value: vehicleBookingsData?.vehicleName },
              {
                name: "Vehicle Registration",
                value: vehicleBookingsData?.vehicleRegistrationNo,
              },
              {
                name: "Seater/Fuel Type",
                value:
                  vehicleDetails?.seater +
                  "/" +
                  fuelType[vehicleDetails?.fuelType],
              },
              {
                name: "Total Free Km",
                value: vehicleBookingsData?.overallFreeKm + " kms",
              },
              {
                name: "Model/Type",
                value:
                  vehicleDetails?.vehicleModelText +
                  "/" +
                  vehicleBodyType[vehicleDetails?.vehicleBodyType],
              },
              {
                name: "Delivery Address",
                value: vehicleBookingsData?.deliveryAddress,
              },
              {
                name: "Pickup Address",
                value: vehicleBookingsData?.pickupAddress,
              },
            ].map(({ name, value }, index) => (
              <div
                key={index}
                className="flex flex-col p-4 bg-white rounded-xl shadow hover:shadow-lg transition-all border border-green-100"
              >
                <h3 className="text-sm font-medium text-gray-500">{name}</h3>
                <p
                  title={value}
                  className="text-lg font-semibold text-gray-800 mt-1 w-66 truncate"
                >
                  {value || "-"}
                </p>
              </div>
            ))}
          </div>
        </div>
      )}

      {vehicleBookingsData ? (
        <></>
      ) : summaryDetails?.bookingStatus ===
        fleetBookingStatus?.inverted?.inquiryClosed ? (
        ""
      ) : (
        availableVehicles &&
        radioValues === "Continue Booking" && (
          <div className="mt-10 px-4">
            <h3 className="text-lg font-semibold mb-4">Select Vehicle</h3>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5">
              {availableVehicles?.map((item) => {
                const isSelected = vehicleDetailsData.id === item.id;

                return (
                  <div
                    key={item.id}
                    onClick={() => {
                      if (hasUnstableConnection) {
                        setPaymentLinkGenerated(false);
                        toast.error(
                          "Please check your network connection. Your internet connection appears to be unstable.",
                          {
                            position: "bottom-center",
                            style: {
                              background: "white", // override background
                              color: "red",
                              fontWeight: "medium",
                              marginBottom: "20px",
                            },
                          },
                        );
                      } else {
                        setVehicleDetailsData((prev) => ({
                          ...prev,
                          id: item.id,
                          name: item.name,
                          vehicleNo: item.licensePlate,
                          comment: prev.comment || "",
                        }));
                      }
                      // Uncomment if needed
                      // getAvailableVehicleINGroup(item.vehicleGroupId);
                    }}
                    className={`cursor-pointer rounded-2xl border-2 p-5 transition-all duration-200 shadow-sm hover:shadow-lg ${
                      isSelected
                        ? "border-blue-600 bg-blue-50 shadow-md"
                        : "border-gray-200 bg-white hover:border-blue-300"
                    }`}
                  >
                    {/* Header */}
                    <div className="flex items-center justify-between">
                      <h4 className="text-lg font-semibold text-gray-800">
                        {item.name}
                      </h4>

                      {isSelected && (
                        <div className="h-6 w-6 rounded-full bg-blue-600 flex items-center justify-center text-white text-xs">
                          ✓
                        </div>
                      )}
                    </div>

                    {/* Vehicle Details */}
                    <div className="mt-4 space-y-2 text-sm text-gray-600">
                      <p>
                        <span className="font-medium">License:</span>{" "}
                        {item.licensePlate}
                      </p>

                      <p className="flex items-center gap-2">
                        <span className="font-medium">Associate Vehicle:</span>
                        <span className="bg-blue-100 text-blue-800 px-2 py-1 rounded-md text-sm font-medium">
                          {item.isAssociateVehicle ? "Yes" : "No"}
                        </span>
                      </p>

                      <p className="flex items-center gap-2 mt-2">
                        <span className="font-medium">Current Odometer:</span>
                        <span className="bg-green-100 text-green-800 px-2 py-1 rounded-md text-sm font-medium">
                          {item.currentOdometer + " Km"}
                        </span>
                      </p>

                      <p>
                        <span className="font-medium">Fuel:</span>{" "}
                        {fuelType[item.fuelType]}
                      </p>

                      <p>
                        <span className="font-medium">Body Type:</span>{" "}
                        {vehicleBodyType[item.vehicleBodyType]}
                      </p>

                      <p>
                        <span className="font-medium">Seats:</span>{" "}
                        {item.seater} Seater
                      </p>
                      
                      <p className="flex items-center gap-2">
                        <span className="font-medium">Is Subscription Enabled:</span>
                        <span className="bg-yellow-100 text-yellow-800 px-2 py-1 rounded-md text-sm font-medium">
                          {item.isSubscriptionEnabled ? "Yes" : "No"}
                        </span>
                      </p>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        )
      )}

      <div class="">
        {/* Continue Inquiry → Show Initiate Booking button */}
        {/* {!vehicleBookingsData && radioValues === "Continue Booking" && (
          <button
            class="mt-4 flex justify-end text-white bg-gradient-to-r from-blue-400 via-blue-500 to-blue-600 hover:bg-gradient-to-br focus:ring-4 focus:outline-none focus:ring-blue-300 shadow-lg font-medium rounded-lg text-md px-5 py-2.5 text-center mr-2 mb-2"
            type="button"
            onClick={() => {
              if (
                !summaryDetails?.deliveryAddress ||
                !summaryDetails?.pickupAddress ||
                !summaryDetails?.destination
              ) {
                return toast.error("Please add pickup and delivery details");
              } else {
                checkVehicleAvailability();
              }
            }}
          >
            Initiate Booking
          </button>
        )} */}

        {/* Close Inquiry → Show Close Inquiry button only */}
        {radioValues === "Close Inquiry" && (
          <>
            <div>
              <input
                type="text"
                className="w-full border border-gray-400 mt-4 rounded-md h-14 p-4"
                placeholder="Enter the Comment"
                value={vehicleDetailsData.comment || ""}
                onChange={(e) =>
                  setVehicleDetailsData((prev) => ({
                    ...prev,
                    comment: e.target.value,
                  }))
                }
              />
            </div>
            <button
              onClick={() => {
                initiateBookingAPI("Close");
              }}
              class="flex justify-end text-white bg-gradient-to-r from-red-500 via-red-600 to-red-700 hover:bg-gradient-to-br focus:ring-4 focus:outline-none focus:ring-red-300 shadow-lg font-medium rounded-lg text-md px-5 py-2.5 text-center mr-2 mb-2 mt-4"
              type="button"
            >
              Close Inquiry
            </button>
          </>
        )}
      </div>

      {/* ) : ( */}
      {/* <div className="text-center text-lg font-semibold mt-4">
          <button
            onClick={() => {
              initiateBookingAPI("Close");
            }}
            class="text-white bg-gradient-to-r from-red-500 via-red-600 to-red-700 hover:bg-gradient-to-br focus:ring-4 focus:outline-none focus:ring-red-300 dark:focus:ring-red-800 shadow-lg shadow-red-500/50 dark:shadow-lg dark:shadow-red-800/80 font-medium rounded-lg text-md px-5 py-2.5 text-center mr-2 mb-2"
            type="button"
          >
            Close Inquiry
          </button>
        </div> */}
      {/* )} */}

      {vehicleBookingsData && radioValues !== "Close Inquiry" && (
        <>
          <div>
            <div className="text-lg font-semibold mt-4">
              <h1>Add Payment Details</h1>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-4 p-2 gap-4 my-4">
              {transactionDetailsInput.map((input, index) => (
                <div key={index}>
                  {input.type === "file" ? (
                    <>
                      <input
                        type="file"
                        accept="image/*" // or any file type
                        onChange={(e) => handleInputChange(input.value, e)}
                      />
                      {errors[input.value] && (
                        <p className="text-red-500 text-sm mt-1">
                          {errors[input.value]}
                        </p>
                      )}
                    </>
                  ) : (
                    <TextField
                      fullWidth
                      type={input.type}
                      label={input.label}
                      disabled={input?.isEnable}
                      value={transactiondetails[input.value] || ""}
                      onChange={(e) => handleInputChange(input.value, e)}
                      error={!!errors[input.value]}
                      helperText={errors[input.value]}
                      InputLabelProps={{ shrink: true }}
                    />
                  )}
                </div>
              ))}
            </div>
          </div>
          <div className="flex justify-end gap-4">
            <button
              onClick={() => {
                if (hasUnstableConnection) {
                  setPaymentLinkGenerated(false);
                  toast.error(
                    "Please check your network connection. Your internet connection appears to be unstable.",
                    {
                      position: "bottom-center",
                      style: {
                        background: "white", // override background
                        color: "red",
                        fontWeight: "medium",
                        marginBottom: "20px",
                      },
                    },
                  );
                } else {
                  if (!paymentLinkGenerated) {
                    generatepaymentlink("generate");
                  }
                }
              }}
              class={`${
                paymentLinkGenerated
                  ? "cursor-not-allowed opacity-50"
                  : "cursor-pointer"
              } text-white font-bold relative text-[14px] w-[14em] h-[3em] text-center bg-gradient-to-r from-violet-500 from-10% via-sky-500 via-30% to-pink-500 to-90% bg-[length:400%] rounded-[30px] z-10 hover:animate-gradient-xy hover:bg-[length:100%] before:content-[''] before:absolute before:-top-[5px] before:-bottom-[5px] before:-left-[5px] before:-right-[5px] before:bg-gradient-to-r before:from-violet-500 before:from-10% before:via-sky-500 before:via-30% before:to-pink-500 before:bg-[length:400%] before:-z-10 before:rounded-[35px] before:hover:blur-xl before:transition-all before:ease-in-out before:duration-[1s] before:hover:bg-[length:10%] active:bg-violet-700 focus:ring-violet-700 hover:brightness-110 hover:-translate-y-[1px] active:brightness-90 active:translate-y-[2px]`}
            >
              + Generate Payment Link
            </button>

            <button
              onClick={handleInitiateBooking}
              disabled={
                ![
                  "transactionid",
                  "transactioncharges",
                  "paymentmode",
                  "payableamount",
                  "paymentremarks",
                  "attachments",
                ].every(
                  (key) =>
                    transactiondetails[key] !== null &&
                    transactiondetails[key] !== undefined &&
                    transactiondetails[key] !== "",
                )
              }
              className={`relative inline-flex items-center gap-2 px-6 py-3 font-semibold text-teal-50 
      bg-gradient-to-tr from-teal-900/50 via-teal-900/90 to-teal-900/30 ring-4 ring-teal-900/20 
      rounded-full overflow-hidden hover:opacity-90 transition-opacity 
      before:absolute before:top-4 before:left-1/2 before:-translate-x-1/2 
      before:w-[100px] before:h-[100px] before:rounded-full before:bg-gradient-to-b 
      before:from-teal-50/10 before:blur-xl
      ${
        ![
          "transactionid",
          "transactioncharges",
          "paymentmode",
          "payableamount",
          "paymentremarks",
          "attachments",
        ].every(
          (key) =>
            transactiondetails[key] !== null &&
            transactiondetails[key] !== undefined &&
            transactiondetails[key] !== "",
        )
          ? "opacity-50 cursor-not-allowed"
          : ""
      }`}
            >
              + Add Payment
            </button>
          </div>
          {addpaymentErrors && (
            <p className="text-red-500 mt-4 text-end">{addpaymentErrors}</p>
          )}

          {hasUnstableConnection && (
            <div className="mt-8 mb-3 flex items-center gap-2 rounded-md border border-red-200 bg-red-50 px-4 py-3 text-sm font-medium text-red-600">
              <InfoIcon />
              <span>
                Slow Network — Your network connection is not stable. Please
                check your internet connection before proceeding.
              </span>
            </div>
          )}

          <table
            className={`min-w-full text-sm text-left shadow-lg border mt-2 ${
              hasUnstableConnection
                ? "bg-red-50 border-red-200"
                : "bg-white border-gray-100"
            }`}
          >
            <thead
              className={hasUnstableConnection ? "bg-red-100" : "bg-gray-50"}
            >
              <tr>
                <th className="p-4">Payment Id</th>
                <th className="p-4">Total Amount</th>
                <th className="p-4">Payment Url</th>
                <th className="p-4">Status</th>
                <th className="p-4">Generated At</th>

                {paymentLink?.status === "captured" ? (
                  <></>
                ) : (
                  <th className="p-4 text-right">Actions</th>
                )}
              </tr>
            </thead>

            <tbody>
              {paymentLink ? (
                <tr
                  key={paymentLink?.id}
                  className={`border-b ${
                    hasUnstableConnection
                      ? "border-red-200 hover:bg-red-100"
                      : "border-gray-100 hover:bg-gray-50"
                  }`}
                >
                  <td className="p-4">{paymentLink?.paymentId}</td>

                  <td className="p-4">{"Rs: " + paymentLink?.amount}</td>

                  <td className="p-4">{paymentLink?.shortUrl}</td>

                  <td className="p-4">{paymentLink?.status}</td>

                  <td className="p-4">
                    {formatDateAndTime(paymentLink?.createdAt)}
                  </td>

                  {paymentLink?.status === "captured" ? (
                    <></>
                  ) : (
                    <td
                      onClick={() => {
                        if (hasUnstableConnection) {
                          setPaymentLinkGenerated(false);

                          toast.error(
                            "Slow Network — Your network connection is not stable. Please check your internet connection.",
                            {
                              position: "bottom-center",
                              style: {
                                background: "white",
                                color: "red",
                                fontWeight: "medium",
                                marginBottom: "20px",
                              },
                            },
                          );
                        } else {
                          if (!paymentLinkGenerated) {
                            generatepaymentlink("actions");
                          }
                        }
                      }}
                      className={`p-4 text-right ${
                        paymentLinkGenerated
                          ? "cursor-not-allowed opacity-50"
                          : "cursor-pointer"
                      }`}
                    >
                      <InfoIcon />
                    </td>
                  )}
                </tr>
              ) : (
                <tr>
                  <td colSpan="6" className="text-center p-4 text-gray-500">
                    No payment links found.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </>
      )}
    </div>
  );
};

export default Initiatebooking;
